// Extracts a human-readable message from an axios error, unwrapping FastAPI/Pydantic
// validation error arrays ({ loc, msg }[]) into "Field x.y: message" strings.
export const extractErrorMessage = (error, fallback) => {
    const detail = error.response?.data?.detail;
    if (Array.isArray(detail)) {
        return detail.map(err => {
            if (err.loc && err.msg) {
                return `Field ${err.loc.join('.')}: ${err.msg}`;
            }
            return err.msg || 'Validation error';
        }).join('; ');
    }
    if (detail) return detail;
    if (error.response?.data?.message) return error.response.data.message;
    if (error.message) return error.message;
    return fallback;
};

// Builds the flattened scraper config sent to the backend: auth fields live at the
// root level (for scraper compatibility) rather than nested under an "auth" key.
export const buildFullScraperConfig = (scraperConfig, authConfig, advancedSettings, categories) => {
    const fullConfig = {
        ...scraperConfig,
        scraper_type: 'generic', // Always use generic for wizard-created e-shops
        login_url: authConfig.login_url,
        username_field: authConfig.username_field,
        password_field: authConfig.password_field,
        login_button: authConfig.login_button,
        modal_container: authConfig.modal_container,
        test_credentials: authConfig.test_credentials,
        advanced: advancedSettings,
        categories: categories
    };
    // Ensure URL fields are explicitly included even if absent from scraperConfig's own keys
    if (scraperConfig.catalog_url !== undefined) fullConfig.catalog_url = scraperConfig.catalog_url;
    if (scraperConfig.url !== undefined) fullConfig.url = scraperConfig.url;
    return fullConfig;
};
